import apiClient from '@/core/api';
import { ENDPOINTS } from '@/features/auth/constants';
import { authStorage } from '../utils';

const useLogoutService = () => {
  const logoutApi = async (refreshToken: string) => {
    const token = authStorage.getToken();

    const res = await apiClient.post(ENDPOINTS.LOGOUT, { refresh_token: refreshToken }, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });

    return res.data;
  };

  return {
    logout: async (refreshToken: string = '') => {
      const response = await logoutApi(refreshToken);
      return response;
    },
  };
};

export default useLogoutService;
